import { theme } from "./theme";

export const LightTheme: any = { ...theme };
